import { render, staticRenderFns } from "./conversions-coming-soon.vue?vue&type=template&id=101a7f06&scoped=true"
import script from "./conversions-coming-soon.vue?vue&type=script&lang=js"
export * from "./conversions-coming-soon.vue?vue&type=script&lang=js"
import style0 from "./conversions-coming-soon.vue?vue&type=style&index=0&id=101a7f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101a7f06",
  null
  
)

export default component.exports